var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3342 35.3335H42.3597V14.257H35.3342V35.3335ZM38.8469 49.3846C39.8422 49.3846 40.6771 49.0473 41.3515 48.3729C42.0236 47.7008 42.3597 46.8671 42.3597 45.8718C42.3597 44.8765 42.0236 44.0417 41.3515 43.3672C40.6771 42.6951 39.8422 42.3591 38.8469 42.3591C37.8517 42.3591 37.018 42.6951 36.3459 43.3672C35.6714 44.0417 35.3342 44.8765 35.3342 45.8718C35.3342 46.8671 35.6714 47.7008 36.3459 48.3729C37.018 49.0473 37.8517 49.3846 38.8469 49.3846ZM3.71939 73.9739V10.7443C3.71939 8.81224 4.40789 7.15774 5.78489 5.78074C7.15955 4.40608 8.81289 3.71875 10.7449 3.71875H66.949C68.881 3.71875 70.5355 4.40608 71.9125 5.78074C73.2872 7.15774 73.9745 8.81224 73.9745 10.7443V52.8973C73.9745 54.8293 73.2872 56.4838 71.9125 57.8608C70.5355 59.2355 68.881 59.9228 66.949 59.9228H17.7704L3.71939 73.9739ZM10.7449 57.0248L14.8724 52.8973H66.949V10.7443H10.7449V57.0248ZM10.7449 10.7443V57.0248V10.7443Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f191b5c87b2d4995a3768edd9bbce206.svg";
export { ForwardRef as ReactComponent };